import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getApiLanguage } from "src/services/commonLanguageHeader";
import {
  getCommandHistory,
  type CommandHistoryParams,
} from "src/services/commandHistoryService";
import { useGeneralRefetchOverride } from "./general.queries";
import { QueryNames } from "./queries.constant";

export const useQueryGetCommandHistory = (
  params?: CommandHistoryParams,
  options: { enabled?: boolean } & Record<string, unknown> = {},
) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);
  const enabled = !!params?.unitId && options.enabled !== false;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.commandHistoryList, params, language],
      queryFn: () => getCommandHistory(params as CommandHistoryParams, language),
      enabled,
      refetchOnMount: true,
      retry: false,
      ...options,
    }),
    enabled,
  );
};
